import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Grid, ProductCard } from 'Blocks'
import get from 'lodash/get'

// TODO to be moved in blocks
class ProductGrid extends Component {
  render() {
    const { products = [], pageName = 'trend' } = this.props
    // remove empty products
    const filteredProducts = products.filter(
      product => get(product, 'uuid', '') !== ''
    )
    // ensure complete rows
    const length = filteredProducts.length
    const rest = length % 4
    const newLength = length - rest

    return filteredProducts.length > 0 ? (
      <div className="products-column">
        <Grid pageName={pageName}>
          {filteredProducts.slice(0, newLength).map((product, index) => (
            <ProductCard
              product={product}
              key={product.uuid}
              position={index}
              pageName={pageName}
              gaEventContext={'Trend Page'}
              showStore
              useCompareModal
            />
          ))}
        </Grid>
      </div>
    ) : null
  }
}

ProductGrid.propTypes = {
  pageName: PropTypes.string,
  products: PropTypes.array
}

export default ProductGrid
